export const STATUS_UNREAD = 'belum_dibaca';
export const STATUS_READ = 'terbaca';
export const STATUS_ARCHIVE = 'arsip';